export const ca = {
    LEFT: 'Esquerra: Mou a la del dia anterior.',
    RIGHT: 'Dreta: Mou-te per al dia següent.',
    DOWN: 'Avall: Mou a la fila següent.',
    UP: 'Amunt: Moure a la fila anterior.',
    PGUP: 'Ctrl + repàg: Moure el mes anterior.',
    PGDOWN: 'Avpàg: passar al següent mes.',
    HOME: 'Home: Mou a l\'any anterior.',
    END: 'Fi: Mou a l\'any següent.',
    ESC: 'Esc/Avui/tanca: Tanca el calendari.',
    TITLE: 'Instruccions Del Teclat'
};
